import './AlertMessages.css';
import { useState } from 'react';
import { Icon, close } from '../Icon/Icon';

export type AlertModel = {
	message: string;
	type: 'success' | 'warning' | 'error';
};

type AlertMessagesProps = {
	alerts: AlertCollection;
};
export const AlertMessages = ({ alerts }: AlertMessagesProps): JSX.Element => {
	return (
		<div>
			{alerts.alerts.map((item, index) => (
				<div key={item.message + '_' + index} className={`alert ${item.type}`}>
					<span>{item.message}</span>
					<span className="close-alert" onClick={(event) => alerts.remove(event, item)}>
						<Icon shape={close} />
					</span>
				</div>
			))}
		</div>
	);
};

export type AlertCollection = {
	alerts: AlertModel[];
	add(alert: AlertModel): void;
	set(alert: AlertModel): void;
	remove(event: React.MouseEvent, alert: AlertModel): void;
	clear(): void;
};
export function useAlerts() {
	const [alerts, setAlerts] = useState<AlertModel[]>([]);
	return {
		alerts,
		add(alert: AlertModel) {
			setAlerts((previous) => [...previous, alert]);
		},
		set(alert: AlertModel) {
			setAlerts([alert]);
		},
		clear() {
			setAlerts([]);
		},
		remove(event: React.MouseEvent, alert: AlertModel) {
			event.stopPropagation();
			setAlerts(alerts.filter((e) => !(e.type === alert.type && e.message === alert.message)));
		},
	};
}
